export default __webpack_public_path__ + "static/media/download_report_button.12ae0aa8.svg";